// Per-template look-and-feel variants, applied as CSS variables by DynamicStyles.
// These go beyond colors: heading character, button case, card shape/shadow and
// image hover behaviour — so switching templates visibly changes the feel.
//
// 'Sports' mirrors the storefront's original design and doubles as the fallback,
// so existing stores look identical until a different template is applied.

const TEMPLATE_STYLES = {
  Sports: {
    headingWeight: 700,
    headingTransform: 'none',
    headingSpacing: '0em',
    buttonTransform: 'uppercase',
    buttonSpacing: '0.02em',
    cardRadius: '0px',
    cardShadow: '0 4px 12px rgba(0,0,0,0.1)',
    cardHoverLift: '-2px',
    imageZoom: 1.08,
    hero: 'slider',
    cardInfo: 'standard',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'teams', 'products', 'community', 'testimonials', 'recommendations'], hide: [] },
    motionSpeed: '0.3s',
    motionEase: 'ease',
    pageBg: '#ffffff',
    surfaceTint: '#f8f8f8',
    cardAspect: null,
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
  Zedify: {
    headingWeight: 600,
    headingTransform: 'none',
    headingSpacing: '0em',
    buttonTransform: 'none',
    buttonSpacing: '0.01em',
    cardRadius: '8px',
    cardShadow: '0 6px 16px rgba(0,0,0,0.08)',
    cardHoverLift: '-3px',
    imageZoom: 1.05,
    hero: 'slider',
    cardInfo: 'standard',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'teams', 'products', 'community', 'testimonials', 'recommendations'], hide: [] },
    motionSpeed: '0.3s',
    motionEase: 'ease',
    pageBg: '#ffffff',
    surfaceTint: '#f0faf9',
    cardAspect: null,
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
  Essence: {
    headingWeight: 600,
    headingTransform: 'none',
    headingSpacing: '0em',
    buttonTransform: 'none',
    buttonSpacing: '0.01em',
    cardRadius: '10px',
    cardShadow: '0 6px 16px rgba(0,0,0,0.09)',
    cardHoverLift: '-3px',
    imageZoom: 1.05,
    hero: 'slider',
    cardInfo: 'quickAdd',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'teams', 'products', 'community', 'testimonials', 'recommendations'], hide: [] },
    motionSpeed: '0.3s',
    motionEase: 'ease',
    pageBg: '#fffaf7',
    surfaceTint: '#fff1ea',
    cardAspect: null,
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
  Modern: {
    headingWeight: 800,
    headingTransform: 'none',
    headingSpacing: '-0.02em',
    buttonTransform: 'uppercase',
    buttonSpacing: '0.08em',
    cardRadius: '2px',
    cardShadow: '0 2px 8px rgba(0,0,0,0.12)',
    cardHoverLift: '-2px',
    imageZoom: 1.05,
    hero: 'split',
    cardInfo: 'chips',
    nav: 'standard',
    footer: 'minimal',
    home: { order: ['hero', 'products', 'trust', 'teams', 'recommendations', 'testimonials', 'community'], hide: [] },
    motionSpeed: '0.25s',
    motionEase: 'ease-out',
    pageBg: '#fafafa',
    surfaceTint: '#f0f0f0',
    cardAspect: '125%',
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'full',
  },
  Fashion: {
    headingWeight: 300,
    headingTransform: 'uppercase',
    headingSpacing: '0.15em',
    buttonTransform: 'uppercase',
    buttonSpacing: '0.12em',
    cardRadius: '0px',
    cardShadow: 'none',
    cardHoverLift: '0px',
    imageZoom: 1.1,
    hero: 'editorial',
    cardInfo: 'centered',
    nav: 'centered',
    footer: 'minimal',
    home: { order: ['hero', 'products', 'teams', 'testimonials', 'trust', 'recommendations', 'community'], hide: ['community'] },
    motionSpeed: '0.5s',
    motionEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    pageBg: '#ffffff',
    surfaceTint: '#f8f5f0',
    cardAspect: '150%',
    imageFit: 'cover',
    sectionHeader: 'centered',
    listing: 'full',
  },
  Tech: {
    headingWeight: 700,
    headingTransform: 'none',
    headingSpacing: '-0.01em',
    buttonTransform: 'none',
    buttonSpacing: '0.02em',
    cardRadius: '6px',
    cardShadow: '0 2px 10px rgba(16,42,67,0.12)',
    cardHoverLift: '-2px',
    imageZoom: 1.04,
    hero: 'split',
    cardInfo: 'chips',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'products', 'teams', 'recommendations', 'testimonials', 'community'], hide: [] },
    motionSpeed: '0.2s',
    motionEase: 'ease-out',
    pageBg: '#f4f7fb',
    surfaceTint: '#ffffff',
    cardAspect: '100%',
    imageFit: 'contain',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
  Fresh: {
    headingWeight: 700,
    headingTransform: 'none',
    headingSpacing: '0em',
    buttonTransform: 'none',
    buttonSpacing: '0.01em',
    cardRadius: '12px',
    cardShadow: '0 8px 20px rgba(27,58,27,0.1)',
    cardHoverLift: '-4px',
    imageZoom: 1.03,
    hero: 'rounded',
    cardInfo: 'quickAdd',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'products', 'teams', 'community', 'testimonials', 'recommendations'], hide: [] },
    motionSpeed: '0.25s',
    motionEase: 'ease',
    pageBg: '#fdfbf5',
    surfaceTint: '#eef7ee',
    cardAspect: '100%',
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
  Beauty: {
    headingWeight: 500,
    headingTransform: 'none',
    headingSpacing: '0.05em',
    buttonTransform: 'none',
    buttonSpacing: '0.04em',
    cardRadius: '16px',
    cardShadow: '0 10px 24px rgba(61,37,48,0.08)',
    cardHoverLift: '-3px',
    imageZoom: 1.05,
    hero: 'rounded',
    cardInfo: 'centered',
    nav: 'centered',
    footer: 'columns',
    home: { order: ['hero', 'products', 'trust', 'testimonials', 'teams', 'community', 'recommendations'], hide: [] },
    motionSpeed: '0.35s',
    motionEase: 'ease-in-out',
    pageBg: '#fff8fa',
    surfaceTint: '#fce9f0',
    cardAspect: '125%',
    imageFit: 'cover',
    sectionHeader: 'centered',
    listing: 'sidebar',
  },
  Playful: {
    headingWeight: 800,
    headingTransform: 'none',
    headingSpacing: '0.01em',
    buttonTransform: 'none',
    buttonSpacing: '0.02em',
    cardRadius: '18px',
    cardShadow: '0 8px 20px rgba(78,52,46,0.12)',
    cardHoverLift: '-6px',
    imageZoom: 1.06,
    hero: 'rounded',
    cardInfo: 'quickAdd',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'teams', 'products', 'community', 'testimonials', 'recommendations'], hide: [] },
    motionSpeed: '0.25s',
    motionEase: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
    pageBg: '#fffdf5',
    surfaceTint: '#fff3e0',
    cardAspect: '110%',
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
  Minimal: {
    headingWeight: 400,
    headingTransform: 'uppercase',
    headingSpacing: '0.1em',
    buttonTransform: 'uppercase',
    buttonSpacing: '0.1em',
    cardRadius: '0px',
    cardShadow: 'none',
    cardHoverLift: '0px',
    imageZoom: 1.02,
    hero: 'editorial',
    cardInfo: 'centered',
    nav: 'centered',
    footer: 'minimal',
    home: { order: ['hero', 'products', 'teams', 'testimonials', 'trust', 'recommendations', 'community'], hide: ['community', 'trust'] },
    motionSpeed: '0.15s',
    motionEase: 'linear',
    pageBg: '#ffffff',
    surfaceTint: '#ffffff',
    cardAspect: '135%',
    imageFit: 'cover',
    sectionHeader: 'centered',
    listing: 'full',
  },
  Lavender: {
    headingWeight: 600,
    headingTransform: 'none',
    headingSpacing: '0.01em',
    buttonTransform: 'none',
    buttonSpacing: '0.02em',
    cardRadius: '10px',
    cardShadow: '0 8px 20px rgba(46,33,64,0.1)',
    cardHoverLift: '-3px',
    imageZoom: 1.05,
    hero: 'gradient',
    cardInfo: 'standard',
    nav: 'standard',
    footer: 'columns',
    home: { order: ['hero', 'trust', 'products', 'teams', 'community', 'testimonials', 'recommendations'], hide: [] },
    motionSpeed: '0.3s',
    motionEase: 'ease',
    pageBg: '#fbf9ff',
    surfaceTint: '#f3ecfd',
    cardAspect: '125%',
    imageFit: 'cover',
    sectionHeader: 'standard',
    listing: 'sidebar',
  },
};

export const getTemplateStyle = (templateName) =>
  TEMPLATE_STYLES[templateName] || TEMPLATE_STYLES.Sports;

export default TEMPLATE_STYLES;
